var map = {
	"./01_Amorim.png": 3856,
	"./02_irinox.png": 4839,
	"./03_Slec.png": 817,
	"./04_AgenziaItalia.png": 9198,
	"./05_Studiomatce.png": 2715,
	"./06_Serena.png": 5475,
	"./07_Garbellotto.png": 3664,
	"./08_ALegal.png": 9881,
	"./09_Crismatica.png": 6522,
	"./10_Sandri.png": 1546,
	"./11_Battistuzzi.png": 9626,
	"./12_Npmedia.png": 5876,
	"./13_Dema.png": 8205,
	"./14_Ops.png": 6114,
	"./15_abs.png": 7464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8669;